// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-container small {
    color: #98bcd5;
    font-weight: bold;
}

.inner-container > div {
    margin-bottom: 20px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlaGljbGUtZGV0YWlsLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxjQUFjO0lBQ2QsaUJBQWlCO0FBQ3JCOztBQUVBO0lBQ0ksbUJBQW1CO0FBQ3ZCIiwiZmlsZSI6InZlaGljbGUtZGV0YWlsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuaW5uZXItY29udGFpbmVyIHNtYWxsIHtcbiAgICBjb2xvcjogIzk4YmNkNTtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbn1cblxuLmlubmVyLWNvbnRhaW5lciA+IGRpdiB7XG4gICAgbWFyZ2luLWJvdHRvbTogMjBweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/vehicle-detail/vehicle-detail.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,4eAA4e","sourcesContent":[".inner-container small {\n    color: #98bcd5;\n    font-weight: bold;\n}\n\n.inner-container > div {\n    margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
